import styled from 'styled-components';
import { PdfViewer } from "../pdfViewer";


const FileViewWrapper = styled.div<{ $imageHeight: string }>`
  width: 100%;
  max-width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    max-width: 100%;
    max-height: ${({ $imageHeight }) => $imageHeight};
  }

  .pdf-viewer {
    width: 100%;
    overflow: auto;
    position: relative;
    max-width: 100%;
  }
`;

export interface IFileViewerProps {
  fileUrl: string;
  fileType?: string;
  pdfHeight?: string;
}

export function FileViewer({fileUrl, fileType, pdfHeight}: IFileViewerProps) {
  const fileExt = fileType || fileUrl?.split(".")?.pop();
  const isPdf = fileExt?.toLowerCase() === 'pdf';

  return (
    <FileViewWrapper $imageHeight={pdfHeight ?? "70vh"}>
      {isPdf ? (
        <div className='pdf-viewer'>
            <PdfViewer fileUrl={fileUrl} pdfHeight={pdfHeight} />
        </div>

      ) : (
        <img src={fileUrl} alt="preview" />
      )}
    </FileViewWrapper>
  );
}
